import { render, staticRenderFns } from "./image-collection.vue?vue&type=template&id=0a4c7fcb&scoped=true"
import script from "./image-collection.vue?vue&type=script&lang=js"
export * from "./image-collection.vue?vue&type=script&lang=js"
import style0 from "./image-collection.vue?vue&type=style&index=0&id=0a4c7fcb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4c7fcb",
  null
  
)

export default component.exports